import { TosClient, DataTransferType,CancelToken,TosClientError, TosServerError } from '@volcengine/tos-sdk';
let tosConfig = {
    accessKeyId: 'AKLTNGVjOGU4MjBlZWEzNGM0MjhjM2ZiMzRhZjY5N2Q1MTc',
    accessKeySecret: 'WkRrNFlXSTVNekJpWWpjNU5HVmxaamhsTmpZME1qUTVZek0xTnpjMk9EZw==',
    region: 'cn-beijing',
    endpoint: 'tos-cn-beijing.volces.com',
};

// 创建客户端
let client = new TosClient(tosConfig);
// 存储桶名称
const bucketName = 'luyou';

// 普通上传
export async function upload(name, data, meta = {}) {
    try {
        // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
        let result = await oss.put(name, data, { meta: meta });
        return result;
    } catch (e) {
        console.log(e);
    }
}

// 分片上传
// export async function multipartUpload(name, data, meta, progressCB) {
//     try {
//         name = name.replaceAll('+','_');
//         let uploadOss = new OSS(ossConfig);
//         // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
//         let result = await uploadOss.multipartUpload(name, data, {
//             progress: function (p, checkpoint) {
//                 progressCB && progressCB(p, checkpoint, uploadOss);
//             },
//             meta: { project: 'titan', ...meta },
//             mime: data.type,
//             timeout: 1800000
//         });
//         return result;
//     } catch (e) {
//         console.log(e);
//         if (e.name == 'cancel')
//             return { message: '暂停上传' };
//         if (e.name == 'abort')
//             return { message: '取消上传' };
//         return { message: '上传失败' };
//     }
// }
let tosCheckpoint = '';
let timer;
const startTime = Date.now();
let uploadedBytes = 0;
let lastUploadedBytes = 0;
let lastTime = startTime;
// 分片上传
export async function multipartUpload(name, fileItem, meta, progressCB) {
    try {
        name = name.replaceAll('+', '_');
        // 移除开头的斜杠（如果存在）
        const cleanName = name.startsWith('/') ? name.substring(1) : name;

        const tosClient = new TosClient(tosConfig);
        // 生成 cancelTokenSource
        const cancelTokenSource = CancelToken.source();
        fileItem[cleanName] = cancelTokenSource;
        // 正确检查断点信息
        let tosCheckpoint = '';
        if (fileItem.hasOwnProperty('checkpoint')) {
            tosCheckpoint = fileItem.checkpoint;
        }
        // 分片大小最小为 5MB
        const partSize = 5 * 1024 * 1024;
        let currentTime = Date.now();
        let elapsedTime = (currentTime - lastTime) / 1000;
        // 更新上传速率
        timer = setInterval(() => {
            if (elapsedTime > 0) {
                const speed = (uploadedBytes - lastUploadedBytes) / elapsedTime;
                if (speed > 0) {
                    const uploadSpeed = speed / 1000 / 1000;
                    if (uploadSpeed > 1) {
                        fileItem.uploadSpeed = `${uploadSpeed.toFixed(2)} MB/S`;
                    } else {
                        fileItem.uploadSpeed = `${(speed / 1024).toFixed(2)} KB/S`;
                    }
                } else {
                    fileItem.uploadSpeed = '0 KB/s';
                }
            }
            lastUploadedBytes = uploadedBytes;
            lastTime = currentTime;
        }, 1000);
        // 上传对象
        const res = await tosClient.uploadFile({
            bucket: 'luyou',
            key: cleanName,
            // 上传的文件路径
            file: fileItem,
            // 上传时指定分片大小
            partSize,
            // 注入断点信息，继续上传
            checkpoint: tosCheckpoint,
            // 分片上传任务并发数量
            taskNum: 5,
            cancelToken: cancelTokenSource.token,
            progress: (percent, checkpoint) => {
                fileItem.percent = Number(percent.toFixed(2));
                fileItem.checkpoint = checkpoint;
                tosCheckpoint = checkpoint;
            },
            // 计算上传速率
            dataTransferStatusChange: (event) => {
                if (event.type === DataTransferType.Started) {
                    fileItem.uploadSpeed = '0 KB/s';
                } else if (event.type === DataTransferType.Rw) {
                    uploadedBytes = event.consumedBytes;
                } else if (event.type === DataTransferType.Succeed) {
                    lastUploadedBytes = 0;
                    uploadedBytes = 0;
                    elapsedTime = 0;
                    fileItem.status = 'success';
                    fileItem.uploadSpeed = '0 KB/s';
                    clearInterval(timer);
                } else if (event.type === DataTransferType.Failed) {
                    lastUploadedBytes = 0;
                    uploadedBytes = 0;
                    elapsedTime = 0;
                    fileItem.status = 'danger';
                    fileItem.uploadSpeed = '0 KB/s';
                    clearInterval(timer);
                }
            },
        });
        return res;
    } catch (error) {
        lastUploadedBytes = 0;
        uploadedBytes = 0;
        fileItem.uploadSpeed = '0 KB/s';
        fileItem.status = 'danger';
        handleUploadError(error,fileItem);
        return error;
    }
}
function handleUploadError(error,fileItem) {
    if (error instanceof TosClientError) {
        console.log('Client Err Msg:', error.message);
        console.log('Client Err Stack:', error.stack);
        fileItem.msg = error.message;
    } else if (error instanceof TosServerError) {
        console.log('Request ID:', error.requestId);
        console.log('Response Status Code:', error.statusCode);
        console.log('Response Header:', error.headers);
        console.log('Response Err Code:', error.code);
        console.log('Response Err Msg:', error.message);
        fileItem.msg = error.message;
    } else {
        console.log('unexpected exception, message: ', error);
        fileItem.msg = error;
    }
}

// 恢复上传。
// let resumeOss = new OSS(ossConfig);
// export async function resumeUpload(name, data, meta, progressCB, ossInstance, fileCheckPoint) {
//     try {
//         let result = await ossInstance.multipartUpload(name, data, {
//             progress: function(p, checkpoint) {
//                 progressCB && progressCB(p, checkpoint, ossInstance);
//             },
//             checkpoint: fileCheckPoint,
//             meta: { project: 'titan', ...meta },
//             mime: data.type,
//             timeout: 1800000
//         });
//         return result;
//     } catch (e) {
//         console.log(e);
//         if (e.name == 'cancel')
//             return { message: '暂停上传' };
//         if (e.name == 'abort')
//             return { message: '取消上传' };
//         return { message: '上传失败' };
//     }
// }
// 恢复上传
export async function resumeUpload(name, data, meta, progressCB, fileCheckPoint) {
    try {
        // 移除开头的斜杠（如果存在）
        const cleanName = name.startsWith('/') ? name.substring(1) : name;

        // 使用 TOS SDK 进行恢复上传
        let result = await client.uploadFile({
            bucket: bucketName,
            key: cleanName,
            file: data,  // 改为 file 而不是 filePath
            progress: function (p, checkpoint) {
                progressCB && progressCB(p, checkpoint, client);
            },
            checkpoint: fileCheckPoint,
            meta: { project: 'titan', ...meta },
            contentType: data.type,
            partSize: 5 * 1024 * 1024, // 5MB分片大小
            timeout: 1800000
        });
        return result;
    } catch (e) {
        console.log(e);
        handleError(e);
        if (e.name == 'cancel')
            return { message: '暂停上传' };
        if (e.name == 'abort')
            return { message: '取消上传' };
        return { message: '上传失败' };
    }
}
// 暂停分片上传。
export function cancel(ossInstance) {
    ossInstance.cancel();
}

export function abortUpload(checkPoint) {
    oss.abortMultipartUpload(checkPoint.name, checkPoint.uploadId);
}

function handleError(error) {
    if (error instanceof TosClientError) {
        console.log('Client Err Msg:', error.message);
        console.log('Client Err Stack:', error.stack);
    } else if (error instanceof TosServerError) {
        console.log('Request ID:', error.requestId);
        console.log('Response Status Code:', error.statusCode);
        console.log('Response Header:', error.headers);
        console.log('Response Err Code:', error.code);
        console.log('Response Err Msg:', error.message);
    } else {
        console.log('unexpected exception, message: ', error);
    }
}
// 获取指定资源下载链接
export function getDownloadUrl(ossObjectName, saveFileName) {
    // 移除开头的斜杠（如果存在）
    const cleanObjectName = ossObjectName.startsWith('/') ? ossObjectName.substring(1) : ossObjectName;

    // 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名
    const contentDisposition = {
        'content-disposition': `attachment; filename*=utf-8''${encodeURIComponent(saveFileName)}`
    };

    // 使用 TOS SDK 生成预签名URL
    const url = client.getPreSignedUrl({
        method: 'GET',
        bucket: bucketName,
        key: cleanObjectName,
        responseContentDisposition: contentDisposition
    });
    return url;
}

/*
* @param prefix指定只列出符合特定前缀的文件
* @param marker指定只列出文件名大于marker之后的文件
* @param delimiter用于获取文件的公共前缀
* @param max-keys用于指定最多返回的文件个数
*/
// 获取oss资源列表
export async function listDir(dir, maxkeys, subDir = true) {
    try {
        // 不带任何参数，默认最多返回1000个文件
        // let result = await oss.list();
        let config = { prefix: dir, 'max-keys': maxkeys };
        if (!subDir) {
            config.delimiter = '/';
        }
        let result = await oss.list(config);
        // 根据nextMarker继续列出文件
        let nextMarker = result.nextMarker;
        if (result.isTruncated) {
            result.objects = result.objects.concat(await (await oss.list({ marker: nextMarker })).objects);
        }

        return result.objects ?? [];
    } catch (e) {
        console.log(e);
    }
}

// 删除资源
export async function delObject(object = '') {
    try {
        let result = await oss.delete(object);
        return result;
    } catch (e) {
        console.log(e);
    }
}

// 批量删除资源
export async function delObjects(objects = [], quiet) {
    try {
        let result = await oss.deleteMulti(objects, {
            quiet: quiet
        });
        return result;
    } catch (e) {
        console.log(e);
    }
}

export async function getUrl(ossObjectName, options = {}) {
    let objectName = ossObjectName.startsWith('/') ? ossObjectName.substring(1) : ossObjectName;
    // 预签名对象下载地址，当 method 为 'GET' 时将 URL 复制到浏览器地址栏中即可访问该对象
    const url = client.getPreSignedUrl({
        // method 支持 'GET'/'PUT'/'HEAD'/'DELETE'
        method: 'GET',
        bucket: bucketName,
        key: objectName,
    });
    // 预签名地址
    // console.log('PreSignedUrl:', url);
    return url;
}